import { React, useState } from "react";
import logo from "./assets/logo.png";
import { CiUser } from "react-icons/ci";
import bannerImage from "./assets/banner.jpg"; // Logo image path
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { FaShieldAlt, FaLeaf, FaRecycle } from "react-icons/fa";
import image from "./assets/image.png";
import image1 from "./assets/image1.png";
import image2 from "./assets/image2.png";
import banner from "./assets/midbanner.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
// Make sure to import your admin icon
import { HiMenu, HiX } from "react-icons/hi";
import { Pagination, Navigation, Autoplay } from "swiper";
import "swiper/css";
import sridharImage from "./assets/pic.png";
import mouneshwaranImage from "./assets/pic1.png";
import hariImage from "./assets/pic2.png";
import returnIcon from "./assets/icons/arrow-right-left.svg";
import shippingIcon from "./assets/icons/la--shipping-fast.svg";
import icon3 from "./assets/icon3.png";
import face from "./assets/face.png";
import twit from "./assets/video.png";
import insta from "./assets/insta.png";
import Product from "./pages/products";
import Blog from "./pages/blog";
import Contact from "./pages/contact";
import ProductDetail from "./pages/productDetail";
import ProductDetail1 from "./pages/productDetail1";
import Product1 from "./pages/product1";
import Product2 from "./pages/product2";
import Product3 from "./pages/product3";
import Product4 from "./pages/product4";
import Product5 from "./pages/product5";
import Product6 from "./pages/product6";
import Product7 from "./pages/product7";
import Product8 from "./pages/product8";
import visionBanner from "./assets/TIPSbannerComfort.jpg"
// Import Pagination directly from 'swiper'

import "./App.css";

function App() {
    return (
        <div className="flex flex-col min-h-screen px-auto">
            <Router>
                <Routes>
                    <Route path="/" element={<MainLayout />} />
                    <Route path="/products" element={<Product />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/contact" element={<Contact />} />

                    {/* Home Route: Product List */}

                    {/* Product Detail Route */}
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/product1" element={<Product1 />} />
                    <Route path="/product2" element={<Product2 />} />
                    <Route path="/product3" element={<Product3 />} />
                    <Route path="/product4" element={<Product4 />} />
                    <Route path="/product5" element={<Product5 />} />
                    <Route path="/product6" element={<Product6 />} />
                    <Route path="/product7" element={<Product7 />} />
                    <Route path="/product8" element={<Product8 />} />
                    <Route path="/product/1" element={<ProductDetail />} />

                    <Route path="/productDetail" element={<ProductDetail />} />
                </Routes>
            </Router>
        </div>
    );
}

function MainLayout() {
    return (
        <>
            <Header />
            <Banner />
            <InfoSection />
            <FeaturesSection />
            <AnimatedBoxes />
            <BannerSection />
            <TestimonialCarousel />
            <Footer />
            {/* <AnimatedBoxes />  */}
        </>
    );
}

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-md">
            <div className="flex items-center justify-between px-4 py-4 lg:mx-20">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img src={logo} alt="Bestie" className="h-16" />
                </div>

                {/* Desktop Menu Section */}
                <nav className="hidden space-x-8 font-sans font-semibold text-xl lg:flex">
                    <a href="/" className="text-gray-700 hover:text-gray-900">
                        HOME
                    </a>
                    <a
                        href="/products"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        PRODUCTS
                    </a>
                    <a
                        href="/blog"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        BLOG
                    </a>
                    <a
                        href="/contact"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        CONTACT
                    </a>
                </nav>

                {/* Search Bar and Admin Section */}

                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="relative hidden">
                        <input
                            type="text"
                            placeholder="Search"
                            className="px-4 py-2 text-sm border border-gray-300 rounded-full outline-none max-sm:hidden max-md:hidden focus:ring-2 focus:ring-gray-500"
                        />
                        <button className="absolute right-2 top-2">
                            <svg
                                className="w-5 h-5 text-gray-500 max-sm:hidden max-md:hidden"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Admin Icon */}
                    <button>
                        <CiUser className="hidden" />
                    </button>

                    {/* Mobile Menu Toggle Button */}
                    <button onClick={toggleMenu} className="lg:hidden">
                        {/* Switch between menu icon and close icon */}
                        {isMenuOpen ? (
                            <HiX className="w-6 h-6 text-gray-700" /> // Close icon when menu is open
                        ) : (
                            <HiMenu className="w-6 h-6 text-gray-700" /> // Menu icon when menu is closed
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="absolute top-0 left-0 z-20 w-2/3 h-full p-6 bg-white shadow-lg lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="mb-8 text-gray-700 hover:text-gray-900"
                    >
                        <HiX className="w-8 h-8" />{" "}
                        {/* Close icon in the mobile menu */}
                    </button>
                    <nav className="flex flex-col space-y-4 font-sans font-semibold">
                        <a
                            href="/"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            HOME
                        </a>
                        <a
                            href="/products"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            PRODUCTS
                        </a>
                        <a
                            href="/blog"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            BLOG
                        </a>
                        <a
                            href="/contact"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            CONTACT
                        </a>
                    </nav>
                </div>
            )}
            <div className="border"></div>
        </header>
    );
}
function Banner() {
    return (
        <div className="relative">
            <img
                src={bannerImage}
                alt="Banner"
                className="max-sm:object-contain max-sm:mx-0 max-sm:mb-0 object-fit lg:w-full lg:h-[90vh] "
            />
            <a href="/products">
                <button className="absolute right-[17%] md:right-[17%] bottom-[6%] md:bottom-[6%] bg-[black] md:bg-[black] text-white h-[8%] w-[15%] rounded-full text-[8px] md:text-[15px] lg:text-[25px] font-sans font-[600]">
                    SHOP NOW
                </button>
            </a>
        </div>
    );
}
function InfoSection() {
    return (
        <section className="py-12 bg-white space-y-10 ">
            <div className="container px-4 mx-auto text-center mt-10 ">
                {/* Heading */}
                <h2 className="font-sans text-2xl font-bold text-gray-800 sm:text-3xl lg:text-4xl mb-10">
                    Bestie Stands With Comfort
                </h2>
                <h2 className="font-sans text-xl font-bold text-gray-600 sm:text-xl lg:text-xl mt-[10px]">
                    Bestie – Your Trusted Companion In Personal Hygiene
                </h2>

                {/* Description */}
                <p className="max-w-6xl mx-auto mt-4 font-sans text-base font-normal leading-relaxed text-gray-600 sm:text-xl lg:text-lg text-justify">
                    At Bestie, we believe that personal hygiene is not just a
                    necessity but a right for everyone. With a commitment to
                    quality, innovation, and care, Bestie stands as a trusted
                    name in the personal hygiene industry, offering a range of
                    premium products that prioritize comfort, protection, and
                    well-being.
                </p>
            </div>
            <div className="container px-4 mx-auto text-center mt-10">
                {/*Heading */}
                <h2 className="font-sans text-xl font-bold text-gray-600 sm:text-xl lg:text-xl mt-[10px]">
                    Our Vision
                </h2>
                {/*Description */}
                <p className="max-w-6xl mx-auto mt-4 font-sans text-base font-normal leading-relaxed text-gray-600 sm:text-xl lg:text-lg">
                    <i>
                        "To find an eternal place in the minds of all consumers
                        through our finest quality products."
                    </i>
                </p>
                <p className="max-w-6xl mx-auto mt-4 font-sans text-base font-normal leading-relaxed text-gray-600 sm:text-xl lg:text-lg text-justify">
                    Bestie is more than just a brand; it is a promise of care,
                    designed to be the best companion in your personal hygiene
                    journey. Whether it’s providing superior sanitary pads for
                    women, baby diapers for little ones, or adult diapers for
                    those who need extra care, we ensure that every product
                    meets the highest standards of safety and efficiency.
                </p>
            </div>
            <div>
            <img src={visionBanner} alt="vision banner" className="w-full"/>
            </div>
            <div className="container px-4 mx-auto text-center mt-10">
                {/*Heading */}
                <h2 className="font-sans text-xl font-bold text-gray-600 sm:text-xl lg:text-xl mt-[10px]">
                    Our Commitment To Quality
                </h2>
                {/*Description */}
                <p className="max-w-6xl mx-auto mt-4 font-sans text-base font-normal leading-relaxed text-gray-600 sm:text-xl lg:text-lg text-justify">
                    Every Bestie product is crafted with precision,
                    incorporating cutting-edge technology and premium materials
                    to deliver unparalleled comfort and protection. From
                    ultra-absorbent cores to skin-friendly fabrics, our products
                    are designed to provide leak-proof security, breathability,
                    and irritation-free comfort —ensuring that you feel fresh,
                    confident, and cared for at all times.
                </p>
            </div>
        </section>
    );
}
function FeaturesSection() {
    return (
        <section className="py-12 bg-white">
            <div className="container px-4 mx-auto">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                    {/* Feature 1 */}
                    <div className=" text-center ">
                        <FaLeaf className="w-16 h-16 mx-auto text-[#52B3A4]" />
                        <h3 className="mt-4 font-sans text-xl font-bold text-gray-800">
                            Quality & Odour Free
                        </h3>
                        <p className="mt-2 font-sans text-lg font-normal text-gray-600">
                            Experience top-quality, odour-free, and spill-proof
                            comfort with every use. Stay confident and protected
                            all day long with our reliable pads
                        </p>
                    </div>

                    {/* Feature 2 */}
                    <div className=" text-center">
                        <FaShieldAlt className="w-16 h-16 mx-auto text-[#52B3A4]" />
                        <h3 className="mt-4 font-sans text-xl font-bold text-gray-800">
                            Comfort
                        </h3>
                        <p className="mt-2 font-sans text-lg font-normal text-gray-600">
                            Experience unmatched comfort with our pads designed
                            for all-day freshness. Soft, breathable, and gentle
                            on your skin, they keep you feeling confident and
                            protected from start to finish.
                        </p>
                    </div>

                    {/* Feature 3 */}
                    <div className=" text-center">
                        <FaRecycle className="w-16 h-16 mx-auto text-[#52B3A4]" />
                        <h3 className="mt-4 font-sans text-xl font-bold text-gray-800">
                            Spil Proof
                        </h3>
                        <p className="mt-2 font-sans text-lg font-normal text-gray-600">
                            Our spill-proof technology guarantees secure
                            protection, keeping you dry and comfortable no
                            matter what. Move with confidence, knowing our pads
                            prevent any leaks or spills.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        // background: linear-gradient(180.12deg, #51B3A4 0.1%, #FFFFFF 99.9%);
        // background: linear-gradient(180deg, #767676 0%, #E2E7EC 100%);
        // background: linear-gradient(180deg, #F6AFB5 0%, #FFE8DB 100%);
    );
}
function AnimatedBoxes() {
    // State to track the active card
    const [activeIndex, setActiveIndex] = useState(1);

    const cards = [
        {
            title: "Gentle & Soft",
            subtitle: "Wet Wipes ",
            image: image2, // Direct reference to the imported image
            background: "linear-gradient(180deg, #767676 0%, #E2E7EC 100%)",
        },
        {
            title: "Ultra Comfort & Confidence",
            subtitle: "Adult Diaper",
            image: image1, // Direct reference to the imported image
            background:
                "linear-gradient(180.12deg, #51B3A4 0.1%, #FFFFFF 99.9%)",
        },
        {
            title: "Stay Fresh & Secure",
            subtitle: "Premium Sanitary Pads",
            image: image, // Direct reference to the imported image
            background: "linear-gradient(180deg, #F6AFB5 0%, #FFE8DB 100%)",
        },
    ];

    const handleCardClick = (index) => {
        setActiveIndex(index);
    };

    return (
        <section className="py-12 bg-white">
            <div className="container px-4 mx-auto">
                <h2 className="mb-8 font-sans text-2xl font-bold text-center text-gray-800 sm:text-3xl lg:text-4xl">
                    Explore Our Promising Line-up
                </h2>
                {/* Add responsive grid layout */}
                <div className="lg:h-[40vh] grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {cards.map((card, index) => (
                        <div
                            key={index}
                            onClick={() => handleCardClick(index)}
                            className={`relative flex flex-col md:flex-row md:items-center justify-between h-auto overflow-hidden transition-transform transform rounded-lg shadow-md cursor-pointer 
                 ${activeIndex === index ? "scale-105 z-10" : "scale-95"} ${
                                activeIndex === index
                                    ? "lg:w-full"
                                    : "lg:w-full"
                            }`}
                            style={{
                                background: card.background,
                                transition:
                                    "transform 0.3s ease, z-index 0.3s ease",
                            }}
                        >
                            {/* Left Side Content */}
                            <div className="p-4">
                                <p className="font-sans text-lg font-bold text-white ">
                                    {card.title}
                                </p>
                                <h3 className="font-sans text-4xl font-bold text-white">
                                    {card.subtitle}
                                </h3>
                                {/* Centered Button */}
                                <div className="mt-8">
                                    <button className="px-4 py-2 font-sans text-sm font-semibold text-gray-800 bg-white rounded-md">
                                        <a href="/products">Explore</a>
                                    </button>
                                </div>
                            </div>

                            {/* Right Side Image */}
                            <div className="p-4 mx-auto">
                                <img
                                    src={card.image}
                                    alt={card.title}
                                    className="w-32 h-auto md:w-48"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

function BannerSection() {
    return (
        <section className="w-full">
            <img
                src={banner}
                alt="Banner"
                className="max-sm:object-contain max-sm:mx-0 max-sm:mb-0 object-fit lg:w-full lg:h-[90vh]"
            />
        </section>
    );
}
function TestimonialCarousel() {
    return (
        <div className="mx-10 mt-10 testimonials-section">
            <h2 className="font-sans text-2xl font-bold text-center">
                TESTIMONIALS
            </h2>
            <br></br>

            <Swiper
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                autoplay={{
                    delay: 3000, // Change slide every 3 seconds
                    disableOnInteraction: false,
                }}
                modules={[Pagination, Navigation, Autoplay]} // Use modules here
                className="mySwiper"
                spaceBetween={30}
                slidesPerView={1} // Default to 1 for mobile
                breakpoints={{
                    640: { slidesPerView: 1 }, // Mobile
                    768: { slidesPerView: 2 }, // Tablet
                    1024: { slidesPerView: 3 }, // Desktop
                }}
            >
                {/* Slide 1 */}
                <SwiperSlide>
                    <div className="p-6 border border-gray-300 rounded-lg shadow-lg testimonial-card">
                        <img
                            src={sridharImage}
                            alt="Sridhar"
                            className="object-cover w-16 h-16 mx-auto rounded-full"
                        />
                        <p className="mt-4 font-sans font-normal text-center">
                            The products are of good quality and at a great
                            price. The funny part is you get to realise how much
                            retailers mark these products up when you buy at
                            medical stores at MRP. 
                        </p>
                        <p className="font-bold text-center">Vidya R</p>
                        <p className="text-center">⭐⭐⭐⭐</p>
                    </div>
                </SwiperSlide>

                {/* Slide 2 */}
                <SwiperSlide>
                    <div className="p-6 border border-gray-300 rounded-lg shadow-lg testimonial-card">
                        <img
                            src={mouneshwaranImage}
                            alt="Mouneshwaran"
                            className="object-cover w-16 h-16 mx-auto rounded-full"
                        />
                        <p className="mt-4 font-sans font-normal text-center">
                            The quality of the baby diapers are very good, I
                            blindly recommend this product to new parenting
                            people to go for it
                        </p>
                        <p className="font-bold text-center">Tajesh B</p>
                        <p className="text-center">⭐⭐⭐⭐⭐</p>
                    </div>
                </SwiperSlide>

                {/* Slide 3 */}
                <SwiperSlide>
                    <div className="p-6 border border-gray-300 rounded-lg shadow-lg testimonial-card">
                        <img
                            src={hariImage}
                            alt="Hari Krishna"
                            className="object-cover w-16 h-16 mx-auto rounded-full"
                        />
                        <p className="mt-4 font-sans font-normal text-center">
                            The diapers are of good quality. I have been buying
                            them for my child for over a year, and they haven't
                            caused any rashes or other issues.
                        </p>
                        <p className="font-bold text-center">Ashwin Padiyar</p>
                        <p className="text-center">⭐⭐⭐⭐⭐</p>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    );
}
function Footer() {
    return (
        <div className=" footer w-full py-7 bg-[#FFB4703D]">
            {/* Logo Row */}
            <div className="flex items-center justify-center">
                <img src={logo} alt="Logo" className="w-32" />
            </div>

            {/* Columns Row */}
            <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-3">
                {/* Column 1 */}
                <div className="flex flex-col items-center">
                    <img
                        src={shippingIcon}
                        alt="Safe Shipping"
                        className="flex flex-row h-12 w-15"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Shipping All Over India
                    </h3>
                </div>

                {/* Column 2 */}
                {/* <div className="flex flex-col items-center">
          <img src={icon1} alt="Secure Payment" className="w-12 h-12" />
          <br></br>
          <h3 className="font-sans font-bold">Secure Payment</h3>
          <p className="font-sans font-normal ">Guaranteed safe checkout</p>
        </div> */}

                {/* Column 3 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon3}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Dedicated Customer Support
                    </h3>
                </div>

                {/* Column 4 */}
                <div className="flex flex-col items-center">
                    <img
                        src={returnIcon}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Safe and quick delivery
                    </h3>
                </div>
            </div>

            {/* Social Media Row */}
            <div className="mt-6 text-center">
                <h3 className="font-sans font-bold">Follow Us</h3>
                <div className="flex justify-center mt-2 space-x-4">
                    <a
                        href="https://www.facebook.com/bestie.care.hygiene/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={face} alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.youtube.com/@BestieHygiene"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={twit} alt="youtube" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.instagram.com/bestie.hygienecare/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D# "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={insta} alt="Instagram" className="w-8 h-8" />
                    </a>
                </div>
            </div>

            {/* Copyright Row */}
            <div className="w-full mx-0 bg-[#52B3A4] py-4 mt-6 text-center text-white font-sans">
                <p>
                    &copy; {new Date().getFullYear()} Bestie Care. All Rights
                    Reserved.
                </p>
            </div>
        </div>
    );
}

export default App;
